import { render, staticRenderFns } from "./CompanySettingsForm.vue?vue&type=template&id=296484ba&scoped=true"
import script from "./CompanySettingsForm.vue?vue&type=script&lang=js"
export * from "./CompanySettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296484ba",
  null
  
)

export default component.exports